const IFRAME_PROPS = {
  allow: 'camera; microphone; geolocation; bluetooth; usb; hid; accelerometer',
  allowFullScreen: false,
  allowpaymentrequest: false,
  id: 'method-iframe',
  importance: 'low',
  seamless: true,
  role: 'application',
  sandbox:
    ' allow-scripts allow-same-origin  allow-popups allow-forms  allow-popups-to-escape-sandbox  allow-top-navigation',
  title: 'method-iframe',
};

export { IFRAME_PROPS };
